export default __webpack_public_path__ + "static/media/bhaktij-koli.ddf55783.jpg";